export const decodePath = (encodedPath: string) => {
  const len = encodedPath.length || 0
  const path = new Array(Math.floor(encodedPath.length / 2))
  let index = 0
  let lat = 0
  let lng = 0

  for (let pointIndex = 0; index < len; ++pointIndex) {
    let result = 1
    let shift = 0
    let b
    do {
      b = encodedPath.charCodeAt(index++) - 63 - 1
      // eslint-disable-next-line no-bitwise
      result += b << shift
      shift += 5
    } while (b >= 0x1f)

    // eslint-disable-next-line no-bitwise
    lat += result & 1 ? ~(result >> 1) : result >> 1

    result = 1
    shift = 0
    do {
      b = encodedPath.charCodeAt(index++) - 63 - 1
      // eslint-disable-next-line no-bitwise
      result += b << shift
      shift += 5
    } while (b >= 0x1f)

    // eslint-disable-next-line no-bitwise
    lng += result & 1 ? ~(result >> 1) : result >> 1

    path[pointIndex] = { lat: lat * 1e-5, lng: lng * 1e-5 }
  }

  return path as Array<{ lat: number; lng: number }>
}
